import { useMutation, useQuery } from "@tanstack/react-query";
import axiosBaseURL from "..";
import { useAuth, AuthContextValue } from "../../providers/AuthProvider";

export const useGetOffTakerDashboardValues = () => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["off taker dashboard values"],
    staleTime: Number(process.env.REACT_APP_STALE_TIME),
    queryFn: async () => {
      const result = await axiosBaseURL.get("/off-taker/dashboard", {
        headers: {
          header: `${user?.userId}/${user?.token}`,
          Authorization: authString,
        },
      });

      return result;
    },
  });
};

export const useOrderList = (options?: {
  orgId: number;
  status:
    | "ACCEPTED"
    | "DELIVERED"
    | "INPROGRESS"
    | "PENDING"
    | "REJECTED"
    | "COMPLETED"
    | undefined;
}) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["get orders", options],
    staleTime: 120,
    queryFn: async () => {
      const orgStr = options?.orgId ? `orgId=${options.orgId}` : "";
      const queryString = options?.status
        ? `${orgStr}&status=${options?.status}`
        : `${orgStr}`;

      const result = await axiosBaseURL.get(
        `/off-taker/orders?${queryString}`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};

export const useMyOrderList = (options?: {
  search?: string;
  status: string | undefined;
}) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["get my orders", options],
    staleTime: 120,
    queryFn: async () => {
      const searchString = options?.search ? `&search=${options?.search}` : "";
      const queryString = options?.status
        ? `orgId=${user?.mfiId}${searchString}&status=${options?.status}`
        : `orgId=${user?.mfiId}&${searchString}`;

      const result = await axiosBaseURL.get(
        `/off-taker/orders/?${queryString}`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
            // Authorization: authString,
          },
        },
      );

      return result;
    },
  });
};

export const useOrderDetail = (id: string) => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["order", id],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/off-taker/orders/${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
          Authorization: authString,
        },
      });

      return result;
    },
  });
};

export const useMyOrderDetail = (id: string) => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["order", id],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/off-taker/orders/${id}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
          Authorization: authString,
        },
      });

      return result;
    },
  });
};

export const useGetOrderStatusCount = () => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["orders status"],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(`/off-taker/status`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};
// export const useOrderStatus = () => {
//     const { profile } = useAuth();
//     return useQuery({
//         queryKey: ['order'],
//         staleTime: 120,
//         queryFn: async () => {
//             const result = await supabase.rpc('get_my_order_status_count', { p_id: profile?.id!});

//             return result;
//         },
//     });
// }

export const useGetVCEByOrderId = (orderId?: string) => {
  const { authString, user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["vce by order id.", orderId],
    staleTime: 120,
    queryFn: async () => {
      const queryString = orderId ? `?orderId=${orderId}` : "";
      const result = await axiosBaseURL.get(`/operation/vce${queryString}`, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      // const _result = {
      //     data: [
      //         { id: 1, fullName: "Seife Hayle", email: "seife@example.com", phoneNumber: "012345678" },
      //         { id: 2, fullName: "Dagmawi Tadesse", email: "dagtad@example.com", phoneNumber: "012345678" },
      //     ]
      // }
      return result;
    },
  });
};

export const useGetBanksByOrderId = (orderId?: string) => {
  const { user } = useAuth() as AuthContextValue;
  return useQuery({
    queryKey: ["useGetBanksByOrderId", orderId],
    staleTime: 120,
    queryFn: async () => {
      const result = await axiosBaseURL.get(
        `/operation/loaner?orderId=${orderId}`,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};

export const useGetOrderById = (id: string) => {
  return useQuery({
    queryKey: ["useGetOrderById", id],
    staleTime: 120,
    queryFn: async () => {
      // const result = await supabase.from('order').select('*, contract(*)').eq('id', id).single();
      // return result;
    },
  });
};

export const useCreateOrder = () => {
  const { refetch } = useMyOrderList();
  const { user } = useAuth() as AuthContextValue;

  return useMutation({
    mutationFn: async (order: any) => {
      order.org_Id = user?.mfiId;
      order.land_size = undefined;
      const result = await axiosBaseURL.post(`/off-taker/createOrder/`, order, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      refetch();
      return result;
    },
  });
};

export const useUpdateOrder = () => {
  const { refetch } = useMyOrderList();
  const { user } = useAuth() as AuthContextValue;

  return useMutation({
    mutationFn: async (order: any) => {
      order.org_Id = user?.mfiId;
      order.land_size = undefined;
      const result = await axiosBaseURL.put(
        `/off-taker/order/edit?id=${order.id}`,
        order,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      refetch();
      return result;
    },
  });
};

export const useUpdateOrderStatus = () => {
  const { refetch } = useMyOrderList();
  const { user } = useAuth() as AuthContextValue;

  return useMutation({
    mutationFn: async (data: { orderId: string; status?: string }) => {
      const result = await axiosBaseURL.put(
        `/off-taker/order/${data.orderId}/status`,
        {
          status: data.status,
        },
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      refetch();
      return result;
    },
  });
};

// export const useUpdateOrder = () => {
//     const { refetch } = useOrderList();
//     return useMutation({
//         mutationFn: async (order: { id: string, data: UpdateTables<'order'> }) => {
//             const result = await supabase.from('order').update(order.data).eq('id', order.id);
//             if (result.error) {
//                 throw new Error(result.error.message);
//             }

//             refetch();
//             return result;
//         }
//     })
// };

export const useDeleteOrder = () => {
  const { refetch } = useOrderList();
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (id: string) => {
      try {
        const result = await axiosBaseURL.delete(`/order/${id}`, {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        });

        refetch();
        return result;
      } catch (error) {
        return error;
      }
    },
  });
};

export const useAddVCEOrder = () => {
  const { refetch } = useOrderList();
  const { user, authString } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (vce_order: { orderId: number; userId: number }) => {
      const result = await axiosBaseURL.post(
        `/off-taker/order/vce`,
        vce_order,
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      refetch();
      return result;
    },
  });
};

export const useRemoveVCEOrder = () => {
  const { refetch } = useOrderList();
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (id: number) => {
      const result = await axiosBaseURL.patch(
        `/operation/vce/inactive?id=${id}`,
        {},
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      refetch();
      return result;
    },
  });
};

export const useAddFinancialInstituteToOrder = () => {
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (bank_order: { orderId: number; orgId: number }) => {
      const result = await axiosBaseURL.post(`/operation/loan`, bank_order, {
        headers: {
          header: `${user?.userId}/${user?.token}`,
        },
      });

      return result;
    },
  });
};

export const useRemoveBankFromOrder = () => {
  const { user } = useAuth() as AuthContextValue;
  return useMutation({
    mutationFn: async (id: number) => {
      const result = await axiosBaseURL.put(
        `/operation/loaned?id=${id}`,
        {},
        {
          headers: {
            header: `${user?.userId}/${user?.token}`,
          },
        },
      );

      return result;
    },
  });
};
